import type { Key } from 'react';
import { z } from 'zod';
import type { PartialUndefinedOrNull } from '@/types/partial';
import { CidadeSchema } from '@/features/cidade-uf-pais/types';
import { NotNullStringSchema } from '@/std/schema';

export const EnderecoSchema = z.object({
    cidade: CidadeSchema.nullable(),
    end_bairro: NotNullStringSchema,
    end_cep: NotNullStringSchema,
    end_cidade_idpk: z.number().nullable(),
    end_complemento: NotNullStringSchema,
    end_descricao: NotNullStringSchema,
    end_empresa_idpk: z.number(),
    end_idpk: z.number(),
    end_logradouro: z.string(),
    end_numero: NotNullStringSchema,
    end_pais: z.string().nullable(),
    end_pais_idpk: z.number().nullable(),
    end_pessoa_idpk: z.number(),
    end_principal: z.union([z.literal(0), z.literal(1)]),
    end_tipocorrespondencia: z.union([z.literal(0), z.literal(1)]),
    end_tipoentrega: z.union([z.literal(0), z.literal(1)]),
    end_tipogeral: z.union([z.literal(0), z.literal(1)]),
    end_ultima_alteracao: z.string().nullable(),
});

export type Endereco = z.infer<typeof EnderecoSchema>;

export type EnderecoBody = PartialUndefinedOrNull<Endereco> & {
    key: Key;
    excluir?: 'S';
};
